// extracted by mini-css-extract-plugin
export default {"container":"styles_container__Pt8y4","formContainer":"styles_formContainer__ngsoz","formWrapper":"styles_formWrapper__AgI6u","formContent":"styles_formContent__RM310"};